import Hero from "@/components/home/Hero";
import MarketTicker from "@/components/home/MarketTicker";
import ServicesPreview from "@/components/home/ServicesPreview";
import LenderNetwork from "@/components/home/LenderNetwork";
import Difference from "@/components/home/Difference";
import Testimonials from "@/components/home/Testimonials";
import AboutPreview from "@/components/home/AboutPreview";
import CtaBand from "@/components/home/CtaBand";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <MarketTicker />
      <ServicesPreview />
      <LenderNetwork />
      <Difference />
      <Testimonials />
      <AboutPreview />
      <CtaBand />
    </div>
  );
}
